import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMicroscope, faArrowUp } from '@fortawesome/free-solid-svg-icons';

const ChatInput = ({ onSendMessage, inputMessage, setInputMessage }) => {
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSendMessage();
        }
    };

    return (
        <div className="omic-atlas-container-bottom-chat-input">
            <div className="omic-atlas-container-bottom-chat-input-top">
                <input 
                    className="omic-atlas-container-bottom-chat-input-topinner" 
                    placeholder="Type your message..." 
                    value={inputMessage}
                    onChange={(e) => setInputMessage(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
            </div>

            <div className="omic-atlas-container-bottom-chat-input-bottom">
                <div className="omic-atlas-container-bottom-chat-input-bottom-inner">          
                    <div className="omic-atlas-container-bottom-chat-input-bottom-left">
                        <div className="omic-atlas-container-bottom-chat-input-bottom-leftbutton">
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                        <div className="omic-atlas-container-bottom-chat-input-bottom-leftbutton">
                            <FontAwesomeIcon icon={faMicroscope} /> Deep Research
                        </div>
                        <div className="omic-atlas-container-bottom-chat-input-bottom-leftbutton">
                            Selected Cohort
                        </div>
                    </div>

                    <div 
                        className="omic-atlas-container-bottom-chat-input-bottom-right"
                        onClick={onSendMessage}
                    > 
                        <FontAwesomeIcon icon={faArrowUp} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatInput;
